import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import {
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
} from '../../constants/main';

import {
    CHECKOUT_FEATURE,
    CHOOSE_SOLUTION,
    CREATE_LISTING,
    CUSTOM_SITE_FEATURE,
    DECISION_MAKING_FEATURE,
    ELEVATE_BRAND,
    EQUIPMENT_RENTALS_FEATURE,
    EXTEND_REACH,
    FREE_ALWAYS_FREE_FEATURE,
    GATHER_TRIBE,
    GET_DETAILS,
    GET_STARTED_MINUTES,
    GET_STARTED_SOLUTION,
    INTEGRATION_FEATURE,
    LEADING_SEARCH_FEATURE,
    LISTING_PAGE_FEATURE,
    MAKE_EXPERIENCE,
    MILLIONS_FEATURE,
    MOBILE_FEATURE,
    ONSITE_LOGISTICS,
    ONSITE_PLANNING,
    ORGANIZER_APP_FEATURE,
    PAYMENT_PROCESSING_FEATURE,
    PROMOTE_BRAND,
    RULE_DAYOF,
    SELL_FEATURE,
    STAFFING_FEATURE,
    TAKE_CONTROL,
    TRACK_ANALYTICS,
    TRANSFORM_VISION,
} from '../../constants/overview';

import {
    MAKER_FAIRE,
    MOZCON,
    SNOWGLOBE,
    THE_YOGA_EXPO,
    YMCA,
} from '../../constants/testimonials';
import * as ORBIT from '../../constants/orbit';

import LogoEColorBrandSvg from 'eventbrite_design_system/iconography/icons/LogoEColorBrand';
import LogoFacebookColorSvg from 'eventbrite_design_system/iconography/icons/LogoFacebookColor';
import LogoSpotifyColorSvg from 'eventbrite_design_system/iconography/icons/LogoSpotifyColor';
import LogoSongkickColorSvg from 'eventbrite_design_system/iconography/icons/LogoSongkickColor';
import LogoBandsintownColorSvg from 'eventbrite_design_system/iconography/icons/LogoBandsintownColor';
import LogoInstagramColorSvg from 'eventbrite_design_system/iconography/icons/LogoInstagramColor';

export default {
    heroBanner: {
        heading: lazyGettext(
            "We're setting the world's stage for live experiences.",
        ),
        CTA: lazyGettext('Create an event'),
        imagePath: 'overview/hero',
        metadataHeading: lazyGettext('SnowGlobe Music Festival'),
        metadataSecondaryHeading: lazyGettext('South Lake Tahoe, CA'),
        dataAutomation: 'overview-hero-banner',
    },
    brandStatementBanner: {
        heading: TRANSFORM_VISION,
    },
    getStartedHeading: {
        heading: GET_STARTED_MINUTES,
        description: CREATE_LISTING,
        CTAText: CHOOSE_SOLUTION,
        imageBackgroundColor: 'mellow-pink',
        imagePath: 'overview/devices-create',
    },
    featureListOne: {
        features: [
            PAYMENT_PROCESSING_FEATURE,
            FREE_ALWAYS_FREE_FEATURE,
            ORGANIZER_APP_FEATURE,
        ],
    },
    takeControlHeading: {
        heading: TAKE_CONTROL,
        description: TRACK_ANALYTICS,
        CTAText: CHOOSE_SOLUTION,
        imageBackgroundColor: 'smart-blue',
        imagePath: 'overview/img-devices-dashboard',
    },
    featureListTwo: {
        heading: ELEVATE_BRAND,
        secondaryHeading: PROMOTE_BRAND,
        features: [LISTING_PAGE_FEATURE, CHECKOUT_FEATURE, CUSTOM_SITE_FEATURE],
        imagePaths: [
            'overview/brand-listing',
            'overview/brand-checkout',
            'overview/brand-website',
        ],
    },
    orbit: {
        heading: GATHER_TRIBE,
        description: EXTEND_REACH,
        stars: [
            {
                name: ORBIT.SUN,
                location: ORBIT.CENTER,
                iconType: <LogoEColorBrandSvg />,
            },
            {
                name: ORBIT.FACEBOOK,
                location: ORBIT.INNER,
                iconType: <LogoFacebookColorSvg />,
            },
            {
                name: ORBIT.SPOTIFY,
                location: ORBIT.INNER,
                iconType: <LogoSpotifyColorSvg />,
            },
            {
                name: ORBIT.SONGKICK,
                location: ORBIT.OUTER,
                iconType: <LogoSongkickColorSvg />,
            },
            {
                name: ORBIT.BANDSINTOWN,
                location: ORBIT.OUTER,
                iconType: <LogoBandsintownColorSvg />,
            },
            {
                name: ORBIT.INSTAGRAM,
                location: ORBIT.OUTER,
                iconType: <LogoInstagramColorSvg />,
            },
        ],
    },
    socialFeatures: {
        features: [
            MILLIONS_FEATURE,
            LEADING_SEARCH_FEATURE,
            INTEGRATION_FEATURE,
        ],
    },
    testimonials: {
        testimonials: [MOZCON, YMCA, THE_YOGA_EXPO, MAKER_FAIRE, SNOWGLOBE],
    },
    makeExperienceFeatures: {
        heading: MAKE_EXPERIENCE,
        secondaryHeading: ONSITE_LOGISTICS,
        features: [MOBILE_FEATURE, SELL_FEATURE, DECISION_MAKING_FEATURE],
        imagePaths: [
            'overview/img-org-app-scan',
            'overview/img-org-app--sell',
            'overview/img-org-app--dashboard',
        ],
    },
    onsiteFeatures: {
        heading: RULE_DAYOF,
        secondaryHeading: ONSITE_PLANNING,
        features: [EQUIPMENT_RENTALS_FEATURE, STAFFING_FEATURE],
    },
    packagesList: {
        heading: GET_STARTED_SOLUTION,
        CTA: GET_DETAILS,
        packages: {
            [PACKAGE_ONE]: {
                name: PACKAGE_ONE_NAME,
                description: lazyGettext(
                    'The essentials you need to start selling tickets in minutes.',
                ),
            },
            [PACKAGE_TWO]: {
                name: PACKAGE_TWO_NAME,
                description: lazyGettext(
                    'A powerful solution to boost sales and grow your business.',
                ),
            },
            [PACKAGE_THREE]: {
                name: PACKAGE_THREE_NAME,
                description: lazyGettext(
                    'Tailored partnership for organizers with large and complex events.',
                ),
            },
        },
    },
};
